import { cssScrollHelper } from './cssScrollHelper.js';
// // const CDN_URL = 'https://static.wixstatic.com/media/';
// const desktopWidths = [480, 768, 1024, 1280, 1440, 1680, 1920, 2560];
// const mobileWidths = [320]; //, 375, 414, 480, 600, 768, 900]; (mobile is currently fixed to 320px)
var getImageStyle = function (item) { return ({
    top: item.offset.top,
    left: item.offset.left,
    width: item.width + item.infoWidth,
    height: item.height + item.infoHeight,
    innerHeight: item.height,
}); };
var createItemId = function (_a) {
    var galleryId = _a.galleryId, item = _a.item;
    return "#pro-gallery-".concat(galleryId, " #").concat(cssScrollHelper.getSellectorDomId(item));
};
var createExactCssForItems = function (id, galleryItems, styleParams) {
    if (id === void 0) { id = ''; }
    var isRTL = styleParams.isRTL;
    var cssStr = '';
    galleryItems.forEach(function (item) {
        var itemId = createItemId({ galleryId: id, item: item });
        var style = getImageStyle(item, styleParams);
        var T = "top:".concat(style.top, "px;");
        var L = isRTL
            ? "right:".concat(style.left, "px;left:auto;")
            : "left:".concat(style.left, "px;");
        var W = "width:".concat(style.width, "px;");
        var H = "height:".concat(style.height, "px;");
        cssStr += "".concat(itemId, " {").concat(T).concat(L).concat(W).concat(H, "}");
        // cssStr += `${id} .gallery-item-wrapper, ${id} .gallery-item-hover, ${id} .gallery-item {${Wvw}${Hvw}}`;
    });
    return cssStr;
};
// const createCssFromLayout = (domId = '', layout, styleParams, width) => {
//   let cssStr = '';
//   const layoutWidth = width - styleParams.imageMargin * 2;
//   const getRelativeDimension = val =>
//     Math.round(10000 * (val / layoutWidth)) / 100;
//   layout.items.forEach((item, i) => {
//     const id = createItemId(domId, item);
//     if (i < 50) {
//       const style = getImageStyle(item, styleParams);
//       const Tvw = `top:${getRelativeDimension(style.top)}vw;`;
//       const Wvw = `width:${getRelativeDimension(style.width)}vw;`;
//       const Hvw = `height:${getRelativeDimension(style.height)}vw;`;
//       const iHvw = `height:${getRelativeDimension(style.innerHeight)}vw;`;
//       const Lpc = `left:${getRelativeDimension(style.left)}%;`;
//       const Wpc = `width:${getRelativeDimension(style.width)}%;`;
//       cssStr += `${id} {${Tvw}${Lpc}${Wpc}${Hvw}}`;
//       cssStr += `${id} .gallery-item-wrapper, ${id} .gallery-item-hover, ${id} .gallery-item {${Wvw}${iHvw}}`;
//     } else {
//       cssStr += `${id}{display:none;}`;
//     }
//   });
//   return cssStr;
// };
// const createCssFromLayouts = (domId, layouts, styleParams, widths) => {
//   const cssStrs = [];
//   layouts.forEach((layout, idx) => {
//     let cssStr = '';
//     if (layout) {
//       const width = widths[idx];
//       const lastWidth = widths[idx - 1];
//       const isFirstMediaQuery = !lastWidth || cssStrs.length === 0;
//       cssStr += isFirstMediaQuery
//         ? ''
//         : `@media only screen and (min-width: ${(lastWidth * 2 + width) /
//             3}px) {`;
//       cssStr += createCssFromLayout(domId, layout, styleParams, width);
//       cssStr += isFirstMediaQuery ? '' : `}`;
//       cssStrs.push(cssStr);
//     }
//   });
//   return cssStrs;
// };
export var createCssLayouts = function (_a) {
    var galleryItems = _a.galleryItems, layoutParams = _a.layoutParams, id = _a.id;
    var exactCss = [];
    exactCss.push(createExactCssForItems(id, galleryItems, layoutParams.styleParams));
    return exactCss;
};
//# sourceMappingURL=cssLayoutsHelper.js.map